export const cccvRoute = {
  mycccv: '/set',
  mint: '/nft/mint',
  pay: '/nft/#{id}/pay', // 일반 구매
  bid: '/nft/#{id}/bid', // 입찰
  offer: '/nft/#{id}/offer', // 제안
  download: '/nft/user/#{pageId}/his/download',
  usageHistory: '/nft/user/#{pageId}/his',
  paymentHistory: '/nft/user/#{pageId}/settle/list',
  myBadge: '/set/badges',
  editProfile: '/nft/user/#{pageId}',
  sellNFT: '/nft/#{tokenId}/sell',
  qr: '/qr',
};

export const keyplayRoute = {
  login: '/login',
  terms: '/terms',
  privacy: '/privacy',
  user: {
    index: '/user/#{pageId}',
    sell: '/user/#{pageId}/sell',
    owned: '/user/#{pageId}/owned',
  },
  nft: '/nft/#{id}',
};
